var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2595_8541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 12.7344V10.625C40 8.20875 38.0412 6.25 35.625 6.25H4.375C1.95875 6.25 0 8.20875 0 10.625V12.7344C0 12.838 0.041155 12.9373 0.114411 13.0106C0.187668 13.0838 0.287025 13.125 0.390625 13.125H39.6094C39.713 13.125 39.8123 13.0838 39.8856 13.0106C39.9588 12.9373 40 12.838 40 12.7344ZM0 12.0156V29.375C0 31.7913 1.95875 33.75 4.375 33.75H35.625C38.0412 33.75 40 31.7913 40 29.375V12.0156C40 11.912 39.9588 11.8127 39.8856 11.7394C39.8123 11.6662 39.713 11.625 39.6094 11.625H0.390625C0.287025 11.625 0.187668 11.6662 0.114411 11.7394C0.041155 11.8127 0 11.912 0 12.0156Z",
    fill: "#F8821B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 15,
    width: 21,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 9,
    width: 21,
    height: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 9,
    height: 9,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 21,
    height: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 24,
    width: 21,
    height: 1,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2595_8541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImg);
export default __webpack_public_path__ + "static/media/card-img.ad8261fd342143eff2c8b172b8475c01.svg";
export { ForwardRef as ReactComponent };